import React from 'react';
import { connect } from 'react-redux';
import R from 'ramda';
import EditLink from './edit-link';
import ErrorCheckIcon from '../../error-check-indicator-icon';
const isNilOrEmpty = R.either(R.isNil, R.isEmpty);


const SingleSection = ({
  text,
  to,
  hide,
  showError,
  onRequestClose,
  openEditDialog,
  hash,
  additionalTexts,
                       }) => {
  return (
    <div style={{ display: hide ? 'none' : 'flex', alignItems: 'flex-start', marginLeft: '24px' }}>
      <ErrorCheckIcon showError={showError} />
      <div style={{ marginLeft: '16px' }}>
        {text}
        <EditLink
          onRequestClose={onRequestClose}
          openEditDialog={openEditDialog}
          hash={hash}
        />
        {Boolean(additionalTexts && additionalTexts.length) && additionalTexts.map((additionalText, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', fontSize: '14px' }}>
          --{additionalText}
        </div>))}
      </div>
    </div>
  );
};

const CheckYourProgress = ({
                             errors,
                             productsMap,
                             contractId,
                             onRequestClose,
                             style,
                             initiateAddEditContractDialog: editFn,
}) => {
  const missingCheck = (category, type) => R.call(R.compose(
    R.contains(type),
    R.propOr([], category)
  ), errors);
  const contractDetailsCheckData = [{
    text: 'Billing Information',
    hash: '#billingInfo',
    hide: !errors.insurance,
    showError: errors.insurance === 'Your insurance document has expired.' || errors.insurance === 'Missing insurance document',
    additionalTexts: [errors.insurance !== 'show' ? errors.insurance : ''].filter(x => x),
    openEditDialog: () => editFn({ type: 'billingInfo', title: 'Edit Billing Information', policiesNotesPage: true }),
  }, {
    text: 'Cancellation Policy',
    hash: '#cancellationPolicy',
    showError: missingCheck('policyMissing', 'cancellation') || errors.incompleteCancellation,
    openEditDialog: () => editFn({ type: 'policy', policyType: 'cancellation', policiesNotesPage: true, title: 'Edit Cancellation Policy' }),
    additionalTexts: [
      missingCheck('policyMissing', 'cancellation') ? '-- Cancellation Policy is required' : '',
      errors.incompleteCancellation ? '-- Incomplete cancellation policy' : '',
    ].filter(x => x),
  }, {
    text: 'Child Policy',
    hash: '#childPolicy',
    showError: missingCheck('policyMissing', 'child') || errors.childInfantOverlap,
    additionalTexts: [errors.childInfantOverlap].filter(x => x),
    openEditDialog: () => editFn({ type: 'policy', policyType: 'child', policiesNotesPage: true, title: 'Edit Child Policy' }),
  },
    // {
  //   text: 'Infant Policy',
  //   hash: '#infantPolicy',
  //   showError: missingCheck('policyMissing', 'infant'),
  // }, {
  //   text: 'Check-in Information',
  //   hash: '#checkInCheckOut',
  //   showError: missingCheck('checkInCheckOutMissing', 'checkIn'),
  //   hide: errors.locProductType === 'Non-Accommodation',
  //   openEditDialog: () => editFn({ type: 'checkInOut', title: 'Edit Check-in & Check-out Policy', policiesNotesPage: true }),
  // }, {
  //   text: 'Check-out Information',
  //   hash: '#checkInCheckOut',
  //   showError: missingCheck('checkInCheckOutMissing', 'checkOut'),
  //   hide: errors.locProductType === 'Non-Accommodation',
  //   openEditDialog: () => editFn({ type: 'checkInOut', title: 'Edit Check-in & Check-out Policy', policiesNotesPage: true }),
  // }
  ];
  return (
    <div style={style}>
      <div style={{ border: '1px solid #e0e0e0', padding: '4% 8%' }}>
        <b>REQUIREMENTS: </b>
        <br/>
        <br/>
        <div style={{ fontSize: '14px', color: 'rgba(0, 0, 0, 0.74)', marginBottom: '24px', display: errors.errorExist ? 'block' : 'none' }}>
          All of the sections below are required in order to complete this template. This information is needed from your partners so they can load and book your products.
        </div>
        <div style={{ textDecoration: 'underline' }}>Policies & Notes</div>
        <br/>
        {
          contractDetailsCheckData.map((obj, i) => (
            <SingleSection
              key={i}
              onRequestClose={onRequestClose}
              {...obj}
            />
          ))
        }
        <br/>
        <div style={{ textDecoration: 'underline' }}>Product{R.pathOr(0, ['products', 'length'], errors) === 1 ? '' : 's'}</div>
        <br/>
        {
          errors.products.map(({
                                 rates,
                                 offers,
                                 allocation,
                                 blackouts,
                                 pickup,
                                 dropoff,
                                 productId,
                                 ratePackageName,
                                 ratePackageIndex,
                                 cancellation,
                                 productType,
                                 ratePackageId,
                               }, index) => {
            const sharedPropsForEdit = {
              productId,
              ratePackageName,
              ratePackageIndex,
              ratePackageId,
            };
            const rpId = (() => {
              if (ratePackageId) return ratePackageId;
              return ratePackageName
              ? encodeURIComponent(ratePackageName)
              : 'Primary';
            })();
            return (
              <div key={index} style={{ marginBottom: index + 1 < R.pathOr(0, ['products', 'length'], errors) ? '12px' : '0px' }}>
                <div style={{ color: 'rgba(0, 0, 0, 0.54)', fontWeight: 'bold' }}>
                  {productsMap[productId]} {ratePackageName ? ` - ${ratePackageName}` : ''}
                </div>
                {
                  [
                    {
                      text: 'Rates', // TITLE
                      showError: R.prop('seasonsCoveringWholePeriod', rates) !== 0
                                  || rates.missingRateSets
                                  || R.prop('emptySeasonDates', rates)
                                  || !isNilOrEmpty(R.prop('overlappedSeasonRates', rates))
                                  || rates.invalidRateDescriptions
                                  || rates.datesOutside,
                      hash: '#seasonRates',
                      to: `/contracting/draft/${contractId}/product/${productId}/${rpId}#seasonRates`,
                      additionalTexts: [
                        rates.missingRateSets ? '-- One or more seasons have missing rates' : '',
                        R.prop('seasonsCoveringWholePeriod', rates) > 0 ? '-- Rates do not cover entire contracting period' : '',
                        R.prop('seasonsCoveringWholePeriod', rates) < 0 ? '-- There are overlapping dates' : '',
                        R.prop('emptySeasonDates', rates) ? '-- One or more seasons have missing dates' : '',
                        !isNilOrEmpty(R.prop('overlappedSeasonRates', rates)) && productType === 'Accommodation' ?
                          '-- One or more seasons have overlapping days of the week and min/max stays' : '',
                        !isNilOrEmpty(R.prop('overlappedSeasonRates', rates)) && productType === 'Non-Accommodation'
                          ? '-- One or more seasons have overlapping days of the week' : '',
                        rates.invalidRateDescriptions ?
                          `-- Some rate types in this rate table are no longer supported, as they cannot be automated into your partners' booking systems.` : '',
                        R.prop('datesOutside', rates) ? '-- Your seasons are not within your contract validity period.' : '',
                      ].filter(x => x),
                    },
                    {
                      text: 'Allocation', // TITLE
                      showError: allocation.allocationMissing || allocation.incompleteAllocation || allocation.datesOutside,
                      hash: '#allocation',
                      openEditDialog: () => editFn({ type: 'allocation', title: 'Edit Allocation', ...sharedPropsForEdit }),
                      additionalTexts: [
                        allocation.allocationMissing ? '-- Allocation information is required' : '',
                        allocation.incompleteAllocation ? '-- Incomplete allocation information' : '',
                        R.prop('datesOutside', allocation) ? '-- Dates fall outside of contracting period' : '',
                      ].filter(x => x),
                    },
                    {
                      text: 'Pick-up', // TITLE
                      showError: pickup.pickupMissing || pickup.incompletePickup || pickup.datesOutside,
                      hide: productType === 'Accommodation',
                      hash: '#pickupDropoff',
                      openEditDialog: () => editFn({
                        type: 'pickupDropoff',
                        title: 'Edit Pick-up / Opening Information',
                        data: { pickupOrDropoff: 'pickup' },
                        ...sharedPropsForEdit,
                      }),
                      additionalTexts: [
                        pickup.pickupMissing ? '-- Pick-up / Opening information is required' : '',
                        pickup.incompletePickup ? '-- Incomplete Pick-up / Opening information' : '',
                        R.prop('datesOutside', pickup) ? '-- Dates fall outside of contracting period' : '',
                      ].filter(x => x),
                    },
                    {
                      text: 'Drop-off', // TITLE
                      showError: dropoff.dropoffMissing || dropoff.incompleteDropoff || dropoff.datesOutside,
                      hide: productType === 'Accommodation',
                      hash: '#pickupDropoff',
                      openEditDialog: () => editFn({
                        type: 'pickupDropoff',
                        title: 'Edit Drop-off / Closing Informationn',
                        data: { pickupOrDropoff: 'dropoff' },
                        ...sharedPropsForEdit,
                      }),
                      additionalTexts: [
                        dropoff.dropoffMissing ? '-- Drop-off / Closing information is required' : '',
                        dropoff.incompleteDropoff ? '-- Incomplete Drop-off / Closing information' : '',
                        R.prop('datesOutside', dropoff) ? '-- Dates fall outside of contracting period' : '',
                      ].filter(x => x),
                    },
                    {
                      text: 'Offers', // TITLE
                      hide: !offers.showOffer,
                      showError: R.prop('emptyDates', offers) || R.prop('datesOutside', offers),
                      hash: '#offers',
                      openEditDialog: () => editFn({
                        type: 'manageExtrasOffers',
                        data: {
                          title: 'Manage Special Offers',
                          type: 'offers',
                        },
                        offersOrExtras: { type: 'offers' },
                        ...sharedPropsForEdit,
                      }),
                      additionalTexts: [
                        R.prop('emptyDates', offers) ? '-- Missing Dates' : '',
                        R.prop('datesOutside', offers) ? '-- Dates fall outside of contracting period' : '',
                      ].filter(x => x),
                    },
                    {
                      text: 'Blackouts', // TITLE
                      hide: !blackouts.showBlackout,
                      showError: R.prop('emptyDates', blackouts) || R.prop('datesOutside', blackouts),
                      hash: '#blackouts',
                      openEditDialog: () => editFn({
                        type: 'blackouts',
                        title: 'Edit Blackouts',
                        ...sharedPropsForEdit,
                      }),
                      additionalTexts: [
                        R.prop('emptyDates', blackouts) ? '-- Missing Dates' : '',
                        R.prop('datesOutside', blackouts) ? '-- Dates fall outside of contracting period' : '',
                      ].filter(x => x),
                    },
                    {
                      text: productType === 'Non-Accommodation' ? 'Product Specific Cancellation Policy' : 'Seasonal Cancellation Policies', // TITLE
                      hide: !cancellation.showCancellation,
                      showError: cancellation.incompleteCancellation || cancellation.datesOutside,
                      hash: '#cancellationPolicy',
                      openEditDialog: () => editFn({
                        type: 'seasonalCancelPolicies',
                        title: productType === 'Non-Accommodation' ? 'Edit Product Specific Cancellation Policies' : 'Edit Season Specific Cancellation Policies',
                        ...sharedPropsForEdit,
                      }),
                      additionalTexts: [
                        cancellation.incompleteCancellation ? '-- Incomplete Cancellation Policy' : '',
                        R.prop('datesOutside', cancellation) ? '-- Dates fall outside of contracting period' : '',
                      ].filter(x => x),
                    },
                  ].map((obj, i) => (
                    <SingleSection
                      key={i}
                      onRequestClose={onRequestClose}
                      {...obj}
                    />
                  ))
                }
              </div>
            );
          })
        }
      </div>
    </div>
  );
};
export default connect(({ contracting }) => ({
  contractId: contracting.publishDraftDialog.get('contractId'),
}), ({
  initiateAddEditContractDialog: payload => ({ type: 'INITIATE_ADD_EDIT_CONTRACT_DIALOG_WITH_TYPE', payload }),
}))(CheckYourProgress);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/draftNTemplate-container/progressIndicatorBar/check-your-progress/main.jsx